import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  query searchTagContent(
    $keywords: String!
    $limit: Int
  ) {
    searchTagContent(
      keywords: $keywords
      limit: $limit
    ) {
      ...ContentFields
    }
  }
  ${ContentFields}
`;
